export default "__VITE_ASSET__CRR_R4UW__"